import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { TripReadyPanelComponent } from './trip-ready-panel/trip-ready-panel.component';

@NgModule({
  declarations: [
    TripReadyPanelComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    NgSelectModule,
    ReactiveFormsModule
  ],
  exports: [
    TripReadyPanelComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class RiskIntelligenceSharedComponentsModule { }
